import { Link } from "react-router-dom";
import { PageHero, CtaSection } from "../components/Sections";
import Seo from "../components/Seo";
import { SERVICES, PROCESS, IMAGES, PAGE_SEO } from "../lib/data";

export default function Services() {
  return (
    <>
      <Seo {...PAGE_SEO.services} />
      <PageHero
        crumb="Services"
        image={IMAGES.services}
        eyebrow="Our Services"
        title="Five ways we help supply chain"
        accent="organizations perform better"
        sub="From a one-time health check to an ongoing fractional partnership — we meet you where you are, and scale our involvement to fit your operation."
      />

      {/* SERVICE DETAIL CARDS */}
      <section id="services">
        <div className="s-inner">
          <div className="services-grid">
            {SERVICES.slice(0, 4).map((s, i) => {
              const Icon = s.icon;
              return (
                <div className={`svc-card fade-up ${i === 1 ? "d1" : i === 2 ? "d2" : ""}`} key={s.slug} id={s.slug}>
                  <div className="svc-icon"><Icon size={22} /></div>
                  <h3>{s.title}</h3>
                  <p>{s.short}</p>
                  <ul className="svc-list">
                    {s.points.map((p) => <li key={p}>{p}</li>)}
                  </ul>
                  <Link to="/contact" className="svc-link">{s.cta} →</Link>
                </div>
              );
            })}

            <div className="svc-card dark span2 fade-up d1" id="fractional-systems-analyst">
              <div className="svc-inner">
                <div className="svc-left">
                  <div className="svc-icon">
                    <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="#00B4D8" strokeWidth="2"><circle cx="12" cy="12" r="3" /><path d="M12 1v4M12 19v4M4.22 4.22l2.83 2.83M16.95 16.95l2.83 2.83M1 12h4M19 12h4M4.22 19.78l2.83-2.83M16.95 7.05l2.83-2.83" /></svg>
                  </div>
                  <h3>Fractional Supply Chain Systems Analyst</h3>
                  <p>Act as an extension of your supply chain systems team — providing expert coverage across WMS, TMS, ERP, EDI, API integrations, and reporting platforms on a flexible monthly basis.</p>
                  <Link to="/contact" className="svc-link">Learn More →</Link>
                </div>
                <div>
                  <p style={{ fontSize: "0.8rem", fontWeight: 700, color: "rgba(255,255,255,0.35)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}>Systems Covered</p>
                  <ul className="svc-list" style={{ marginBottom: 20 }}>
                    <li>WMS &amp; TMS</li>
                    <li>ERP &amp; EDI monitoring</li>
                    <li>API Integrations</li>
                    <li>Reporting platforms &amp; dashboards</li>
                  </ul>
                  <p style={{ fontSize: "0.8rem", fontWeight: 700, color: "rgba(255,255,255,0.35)", textTransform: "uppercase", letterSpacing: "0.08em", marginBottom: 14 }}>What We Do</p>
                  <ul className="svc-list">
                    <li>Integration support &amp; root-cause analysis</li>
                    <li>Data analysis &amp; dashboard development</li>
                    <li>Vendor management</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ENGAGEMENT MODELS */}
      <section id="stats" style={{ background: "var(--off-white)" }}>
        <div className="s-inner">
          <div className="fade-up" style={{ textAlign: "center", marginBottom: 48 }}>
            <span className="s-eye">Engagement Models</span>
            <h2 style={{ color: "var(--text-dark)" }}>Flexible ways to work together</h2>
            <p className="s-lead" style={{ margin: "0 auto" }}>Choose the model that fits your timeline, budget, and the scope of the problem in front of you.</p>
          </div>
          <div className="value-grid fade-up d1">
            <div className="value-card">
              <h4>Hourly</h4>
              <p>Targeted, on-demand expertise for specific questions, troubleshooting, or short bursts of work — billed by the hour with no long-term commitment.</p>
            </div>
            <div className="value-card">
              <h4>Monthly Retainer</h4>
              <p>Ongoing fractional support at a predictable monthly rate — 10, 20, or 40 hours per month — so your team always has an expert on call.</p>
            </div>
            <div className="value-card">
              <h4>Fixed-Scope Project</h4>
              <p>A defined deliverable with a clear timeline and price — ideal for assessments, implementations, and optimization initiatives.</p>
            </div>
          </div>
        </div>
      </section>

      {/* PROCESS RECAP */}
      <section id="process">
        <div className="s-inner">
          <div className="process-hdr fade-up">
            <span className="s-eye">How We Work</span>
            <h2>A process built around your operation</h2>
            <p className="s-lead">No black boxes. No scope creep surprises. A clear path from current state to measurable results.</p>
          </div>
          <div className="steps">
            {PROCESS.map((step, i) => (
              <div className={`step fade-up ${i ? "d" + i : ""}`} key={step.n}>
                <div className="step-bubble">{step.n}</div>
                <h4>{step.title}</h4>
                <p>{step.text}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <CtaSection />
    </>
  );
}
